import React from 'react'
import AiImpactIcon from '../../assets/images/product/menu/ai-impact.svg'
import CiVisibilityIcon from '../../assets/images/product/menu/ci-visibility.svg'
import DeveloperOverviewIcon from '../../assets/images/product/menu/developer-overview.svg'
import DoraMetricsIcon from '../../assets/images/product/menu/dora-metrics.svg'
import EngineeringMetricsIcon from '../../assets/images/product/menu/engineering-metrics.svg'
import InitiativesIcon from '../../assets/images/product/menu/initiatives.svg'
import InvestmentBalanceIcon from '../../assets/images/product/menu/investment-balance.svg'
import NotificationsIcon from '../../assets/images/product/menu/notifications.svg'
// import PullRequestsIcon from '../../assets/images/product/menu/pull-requests.svg'
import SoftwareCapitalizationIcon from '../../assets/images/product/menu/software-capitalization.svg'
import SprintsIcon from '../../assets/images/product/menu/sprints.svg'
import SurveysIcon from '../../assets/images/product/menu/surveys.svg'
import WorkLogIcon from '../../assets/images/product/menu/work-log.svg'
import WorkingAgreementsIcon from '../../assets/images/product/menu/working-agreements.svg'
import BusinessOutcomesIcon from '../../assets/images/icons/business-outcomes.svg'
import DataPlatformIcon from '../../assets/images/icons/data-platform.svg'
import DeveloperExperienceIcon from '../../assets/images/icons/developer-experience.svg'
import DeveloperProductivityIcon from '../../assets/images/icons/developer-productivity.svg'
import IntegrationsIcon from '../../assets/images/icons/integrations.svg'
import ProductOverviewIcon from '../../assets/images/icons/product-overview.svg'
import Box from '../primitives/Box'
import Row from '../primitives/Row'
import Stack from '../primitives/Stack'
import Button from '../system/Button'
import { HoverMenu, HoverMenuItemProps } from './HoverMenu'

export const productPages: HoverMenuItemProps[] = [
  {
    icon: ProductOverviewIcon,
    title: 'Product overview',
    content: 'Get to know Swarmia',
    href: '/product/',
  },
  {
    icon: BusinessOutcomesIcon,
    title: 'Business outcomes',
    content: 'Align engineering with the business',
    href: '/product/business-outcomes/',
  },
  {
    icon: DeveloperProductivityIcon,
    title: 'Developer productivity',
    content: 'Speed up feature delivery',
    href: '/product/developer-productivity/',
  },
  {
    icon: DeveloperExperienceIcon,
    title: 'Developer experience',
    content: 'Get feedback from engineers',
    href: '/product/developer-experience-surveys/',
  },
  {
    icon: DataPlatformIcon,
    title: 'Data platform',
    content: 'Reliably measure and export your data',
    href: '/product/data-platform/',
  },
  {
    icon: IntegrationsIcon,
    title: 'Integrations',
    content: 'See all the systems we support',
    href: '/integrations/',
  },
]

const productFeaturesLeftColumn: FeatureProps[] = [
  {
    title: 'AI impact',
    href: '/product/ai-impact/',
    icon: AiImpactIcon,
  },
  {
    title: 'CI visibility',
    href: '/product/ci-cd-insights/',
    icon: CiVisibilityIcon,
  },
  {
    title: 'Developer overview',
    href: '/product/developer-overview/',
    icon: DeveloperOverviewIcon,
  },
  {
    title: 'DORA metrics',
    href: '/dora-metrics/',
    icon: DoraMetricsIcon,
  },
  {
    title: 'Engineering metrics',
    href: '/product/engineering-metrics/',
    icon: EngineeringMetricsIcon,
  },
  {
    title: 'Initiatives',
    href: '/product/initiatives/',
    icon: InitiativesIcon,
  },
  {
    title: 'Investment balance',
    href: '/product/investment-balance/',
    icon: InvestmentBalanceIcon,
  },
]

const productFeaturesRightColumn: FeatureProps[] = [
  {
    title: 'Notifications',
    href: '/github-slack-integration/',
    icon: NotificationsIcon,
  },
  // TODO: enable when we have a feature page for PRs
  /* {
   *   title: 'Pull requests',
   *   href: '/',
   *   icon: PullRequestsIcon,
   * }, */
  {
    title: 'Software capitalization',
    href: '/product/software-capitalization/',
    icon: SoftwareCapitalizationIcon,
  },
  {
    title: 'Sprints',
    href: '/product/sprints/',
    icon: SprintsIcon,
  },
  {
    title: 'Surveys',
    href: '/product/developer-experience-surveys/',
    icon: SurveysIcon,
  },
  {
    title: 'Work log',
    href: '/product/work-log/',
    icon: WorkLogIcon,
  },
  {
    title: 'Working agreements',
    href: '/product/working-agreements/',
    icon: WorkingAgreementsIcon,
  },
]

export const productFeatures = [
  ...productFeaturesLeftColumn,
  ...productFeaturesRightColumn,
]

export type FooterLink = {
  title: string
  href: string
}

export const productFooterLinks: FooterLink[] = [
  {
    title: 'Security',
    href: '/security/',
  },
  {
    title: 'Swarmia for enterprises',
    href: '/enterprise/',
  },
  {
    title: 'Swarmia for startups',
    href: '/startups/',
  },
]

export function ProductMenu() {
  return (
    <HoverMenu items={productPages}>
      <Features />
    </HoverMenu>
  )
}

function Features() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      paddingX={64}
      paddingY={48}
      color="white"
      css={`
        background: linear-gradient(
          202deg,
          #19386e 6.86%,
          #1a366d 6.87%,
          #241d5d 85.5%
        );
      `}
    >
      <Box
        font="productMenuLink"
        textTransform="uppercase"
        color="darkMenuText"
        marginLeft={12 /* align left side with icons below */}
        // @ts-ignore custom letter spacing
        letterSpacing="0.06em"
      >
        Features
      </Box>
      <Row space={32} marginTop={16}>
        <Stack space={8}>
          {productFeaturesLeftColumn.map(feature => (
            <Feature key={feature.href} {...feature} />
          ))}
        </Stack>
        <Stack space={8}>
          {productFeaturesRightColumn.map(feature => (
            <Feature key={feature.href} {...feature} />
          ))}
        </Stack>
      </Row>
      <Row marginTop={48}>
        {productFooterLinks.map(footerLink => (
          <Button
            key={footerLink.href}
            variant="darkMenuLink"
            href={footerLink.href}
          >
            {footerLink.title}
          </Button>
        ))}
      </Row>
    </Box>
  )
}

type FeatureProps = {
  title: string
  href: string
  icon: string
}

function Feature(props: FeatureProps) {
  return (
    <Button
      variant="darkHoverHighlight"
      href={props.href}
      textAlign="left"
      justifyContent="flex-start"
      paddingY={16}
      paddingLeft={8}
      paddingRight={16}
      color="darkMenuLinkText"
    >
      <Row space={4}>
        <Box display="flex">
          <img src={props.icon} alt={props.title} />
        </Box>
        <Box alignSelf="center" font="textLabel">
          {props.title}
        </Box>
      </Row>
    </Button>
  )
}
